<template lang="pug">
  span
    el-card.box-card.bg-purple
      .clearfix(slot='header')
        | Στατιστικά
        el-button(style='float: right; padding: 3px 0;' type='text'
          @click='toggleStats') Κλείσιμο
      .text.item
        el-switch(
          v-model='searchTypeUsers'
          active-text=' Χρηστών-Ρόλων'
          inactive-text=' Αναγνωρίσεων-Κατάθεσης Αιτήσεων')
        hr
        el-date-picker(
          v-model='dateFrom',
          type='date',
          placeholder='Υποβληθείσες από...',
          format='dd-MM-yyyy',
          value-format='dd-MM-yyyy')
        el-date-picker(
          v-model='dateTo',
          type='date',
          placeholder='...Υποβληθείσες μέχρι',
          format='dd-MM-yyyy',
          value-format='dd-MM-yyyy')
        div
          el-select.big(
            v-show="searchTypeUsers"
            v-model='role'
            v-loading='gettingRoles'
            placeholder='Ρόλος', filterable, clearable)
            el-option(v-for='role in rolesAvailable',
              :key='role.id',
              :label='role.gr_name',
              :value='role.name')
          el-button.searchButton(
            type='primary'
            @click='statsPerRole'
            v-show="searchTypeUsers")  Αναζήτηση Ρόλου
        el-select.big(
          v-show="searchTypeUsers"
          v-model='selectedUser',
          @focus='getUsers'
          v-loading='gettingUsers'
          placeholder='Χρήστης', filterable, clearable)
          el-option(v-for='user in users',
            :key='user.id',
            :label='user.name',
            :value='user.id')
        el-button.searchButton(
            type='primary'
            @click='statsPerUser'
            v-show="searchTypeUsers")  Αναζήτηση Χρήστη
        el-select.big(
          v-show="!searchTypeUsers"
          v-model='selectedAcademicArea',
          @focus='getAcademicAreas'
          v-loading='gettingAcademicAreas'
          placeholder='Ακαδημαϊκή πειριοχή', filterable, clearable)
          el-option(v-for='area in academicAreas',
            :key='area.id',
            :label='area.name',
            :value='area.id')
        el-select.big(
          v-show="!searchTypeUsers"
          v-model='selectedCountry',
          @focus='getCountries'
          v-loading='gettingCountries'
          placeholder='Χώρα', filterable, clearable)
          el-option(v-for='country in countries',
            :key='country.id',
            :label='country.name',
            :value='country.id')
        el-select.big(
          v-show="!searchTypeUsers"
          v-model='selectedAppType',
          @focus='getAppTypes'
          v-loading='gettingAppTypes'
          placeholder='Τύπος Αίτησης', filterable, clearable)
          el-option(v-for='appType in appTypes',
            :key='appType.id',
            :label='appType.name',
            :value='appType.id')
        el-select.big(
          v-show="!searchTypeUsers"
          v-model='selectedSortBy',
          placeholder='Ταξινόμηση με', filterable, clearable)
          el-option(v-for='sortBy in sortChoises',
            :key='sortBy',
            :label='sortBy',
            :value='sortBy')
        //
          <el-select class="big" v-model="statsType" placeholder="Τύπος Αίτησης" filterable="filterable" clearable="clearable" v-on:keyup.enter.native="statsApps">
          <el-option v-for="appType in appTypes" :key="appType.id" :label="appType.name" :value="appType.id"></el-option>
          </el-select>
        p
          el-button.searchButton(
            type='primary'
            @click='statsRecognSubmit'
            v-show="!searchTypeUsers") Αναζήτηση
        p
          span(v-html='json')
        //
          <el-table stripe="stripe" border="border" highlight-current-row="highlight-current-row" :data="tableStats" v-loading="loadingStats">
          <el-table-column label="Κατάσταση"  width="300">
          <template slot-scope="scope">
          <span>{{ scope.row.name }}</span>
          </template>
          </el-table-column>
          <el-table-column label="Πλήθος αιτήσεων"  width="200">
          <template slot-scope="scope">
          <span>{{ scope.row.len }}</span>
          </template>
          </el-table-column>
          </el-table>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import terms from '../../store/terms'
import axios from 'axios'
import config from '../../config.js'
import sharedMethods from '../common/sharedMethods.js'

export default {
  components: {
    terms
  },
  mixins: [sharedMethods],
  props: [],
  data () {
    return {
      searchTypeUsers: true,
      users: [],
      sortChoises: ['country', 'applicationType', 'decisionType', 'section'],
      gettingUsers: false,
      gettingRoles: false,
      gettingAppTypes: false,
      gettingAcademicAreas: false,
      appStates: terms.appStates,
      appTypes: terms.appTypes,
      // role: 'fromSearchedApps',
      dateFrom: '',
      dateTo: '',
      selectedUser: '',
      selectedAcademicArea: '',
      selectedCountry: '',
      selectedAppType: '',
      selectedSortBy: '',
      role: '',
      statsType: '',
      json: ''
    }
  },
  methods: {
    getAcademicAreas () {
      this.$store.dispatch('LOAD_ACADEMIC_AREAS')
    },
    getCountries () {
      this.$store.dispatch('LOAD_COUNTRIES')
    },
    getAppTypes () {

    },
    getUsers () {
      if (this.users.length === 0) {
        this.gettingUsers = true
        axios.get(`${this.BASE_URL}/statistics/users`).then((response) => {
          this.users = response.data.data
          this.gettingUsers = false
        }, (err) => {
          this.users = []
          this.gettingUsers = false
          this.backendError(err)
        })
      }
    },
    toggleStats () {
      this.$store.dispatch('SHOW_HIDE_STATS')
    },
    // /recognitions/?date-from=03-12-2019&date-to=08-12-2020&section-id=26&country=281&type=1100&sortBy=country
    statsRecognSubmit () {
      axios.get(
        `${config.BASE_URL}/statistics/recognitions?
date-from=${this.dateFromVal}&
date-to=${this.dateToVal}&
section-id=${this.selectedAcademicArea ? this.selectedAcademicArea : ''}&
country=${this.selectedCountry ? this.selectedCountry : ''}&
type=${this.selectedAppType ? this.selectedAppType : ''}&
sortBy=${this.selectedSortBy ? this.selectedSortBy : ''}`
      ).then((response) => {
        this.json = this.printJson(response.data.data)
        // this.json = JSON.stringify(response.data.data, null, 2)
      }, (err) => {
        console.log(err)
      })
    },
    statsPerRole () {
      axios.get(
        `${config.BASE_URL}/statistics/${this.role}?date-from=${this.dateFromVal}&date-to=${this.dateToVal}`
      ).then((response) => {
        this.json = this.printJson(response.data.data)
      }, (err) => {
        console.log(err)
      })
    },
    statsPerUser () {
      // get role stats for all users
      axios.get(
        `${config.BASE_URL}/statistics/user?user=${this.selectedUser}&date-from=${this.dateFromVal}&date-to=${this.dateToVal}`
      ).then((response) => {
        this.json = this.printJson(response.data.data)
      }, (err) => {
        console.log(err)
      })
    }
  },
  computed: {
    dateToVal () {
      return this.dateTo ? this.dateTo : ''
    },
    dateFromVal () {
      return this.dateFrom ? this.dateFrom : ''
    },
    rolesAvailable () {
      return [
        {gr_name: 'Υπάλληλος Προελέγχου', id: 1, name: 'prechecker'},
        {gr_name: 'Eιδικός Eισηγητής', id: 2, name: 'specialproponent'},
        {gr_name: 'Υπάλληλος Διοικητικού Ελέγχου', id: 8, name: 'processviewer'}
      ]
    },
    ...mapGetters(['activeRole', 'currentUser', 'roles']),
    ...mapState([
      'stats',
      'loadingStats',
      'BASE_URL',
      'academicAreas',
      'countries',
      'gettingCountries'
    ])
  }
}
</script>

<style lang="scss" scoped>
.nested {
  color: #409e55;
}

.numStat {
  background-color: rgba(64,158,255,.1);
  display: inline-block;
  padding: 0 10px;
  height: 32px;
  line-height: 30px;
  font-size: 12px;
  color: #409eff;
  border-radius: 4px;
  box-sizing: border-box;
  border: 1px solid rgba(64,158,255,.2);
  white-space: nowrap;
}

.el-select {
    &.big {
      width: 440px;
    }
    &.biggest {
      width: 1100px;
    }
    &.countries {
      width: 440px;
    }
  }
  .searchButton {
    margin-left: 30px
  }
  .el-input {
    width: 200px
  }
</style>



// WEBPACK FOOTER //
// src/components/common/Statistics.vue